// extracted by mini-css-extract-plugin
export var actions = "_z-0";
export var actionsContainer = "_z-7";
export var border = "_z-1";
export var childFullHeight = "_z-f";
export var collapse = "_z-2";
export var content = "_z-a";
export var contentChild = "_z-e";
export var fullscreen = "_z-c";
export var hasLeftRadius = "_z-k";
export var headerContainer = "_z-3";
export var headerRow = "_z-5";
export var hidePadding = "_z-b";
export var navCollapsedGap = "_z-l";
export var noScrollX = "_z-m";
export var noScrollY = "_z-n";
export var noTopPadding = "_z-i";
export var optOutTopPadding = "_z-d";
export var pageMain = "_z-j";
export var pageOuter = "_z-g";
export var pagePadding = "_z-8";
export var pageScroll = "_z-9";
export var profile = "_z-o";
export var profileContainer = "_z-p";
export var profileImage = "_z-q";
export var profileMain = "_z-r";
export var profileSubtitle = "_z-t";
export var profileTitle = "_z-s";
export var showLeftPadding = "_z-h";
export var tabsPortalSlot = "_z-6";
export var tabsWrapper = "_z-4";
export var title = "_z-u";